import React, { useEffect, useState } from "react";
import { Card, Spin, Alert, Divider, Segmented, Space, Grid } from "antd";
import moment from "moment";
import reportSvc from "../services/reportSvc";
import { useLocation } from "react-router-dom";
import LaporanInformationCard from "../components/LaporanInformationCard";
import { pelanggan } from "../utils/PelangganMapper";
import DetailLaporanModal from "../components/DetailLaporanModal";

moment.tz.setDefault("Asia/Bangkok");

export default function ReportPage({ cabang }) {
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [reportExports, setReportExport] = useState([]);
  const [daysInRange, setDaysInRange] = useState(0);

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedAssetName, setSelectedAssetName] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let query_pel;
  if (cabang) {
    query_pel = cabang;
  } else {
    query_pel = queryParams.get("cabang");
  }
  const id_pelanggan = pelanggan[query_pel] || null;

  const updateDaysInRange = () => {
    const start = moment(startDate);
    const end = moment(endDate);
    const days = end.diff(start, "days") + 1;
    setDaysInRange(days);
  };

  const fetchReportsExport = async () => {
    if (!id_pelanggan) {
      return;
    }
    try {
      setIsLoading(true);
      const respdata = await reportSvc.getReportExportDailyNoAuth({
        params: {
          start_date: startDate,
          end_date: endDate,
          id_pelanggan,
        },
      });
      if (respdata.status === 200) {
        setReportExport(respdata.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch reports", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateDaysInRange();
  }, [startDate, endDate]);

  useEffect(() => {
    if (id_pelanggan) {
      fetchReportsExport();
    }
  }, [id_pelanggan, startDate, endDate]);

  const generateDateLabels = (startDate, daysInRange) => {
    const labels = [];
    for (let i = 0; i < daysInRange; i++) {
      const date = moment(startDate).add(i, "days");
      labels.push(date.format("D MMM"));
    }
    return labels;
  };

  const renderTableHeaders = () => {
    return (
      <>
        <tr
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "#f5f5f5", // Background color to prevent overlap
            zIndex: 2, // Ensure it stays above other rows
          }}
        >
          <th
            style={{
              textAlign: "center",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "8px",
            }}
            colSpan={3}
          >
            INFORMASI ATM
          </th>
          <th
            style={{
              textAlign: "center",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "8px",
            }}
            colSpan={daysInRange * 3}
          >
            TANGGAL
          </th>
        </tr>
        <tr
          style={{
            position: "sticky",
            top: 40, // Adjust this value if header height changes
            backgroundColor: "#f5f5f5", // Match header background
            zIndex: 1, // Ensure it stays just below the main header
          }}
        >
          <th
            style={{
              textAlign: "center",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "8px",
            }}
            rowSpan={2}
          >
            No
          </th>
          <th
            style={{
              textAlign: "center",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "8px",
            }}
            rowSpan={2}
          >
            ID ATM
          </th>
          <th
            style={{
              textAlign: "center",
              fontWeight: "bold",
              border: "1px solid #ccc",
              padding: "8px",
            }}
            rowSpan={2}
          >
            Nama ATM
          </th>
          {generateDateLabels(startDate, daysInRange).map((label, index) => (
            <th
              key={index}
              colSpan={3}
              style={{
                textAlign: "center",
                fontWeight: "bold",
                border: "1px solid #ccc",
                padding: "8px",
              }}
            >
              {label}
            </th>
          ))}
        </tr>
        <tr
          style={{
            position: "sticky",
            top: 80, // Adjust this based on cumulative header height
            backgroundColor: "#f5f5f5", // Match header background
            zIndex: 1,
          }}
        >
          {Array.from({ length: daysInRange }, (_, index) => (
            <>
              <th
                key={`sub-1-${index}`}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  border: "1px solid #ccc",
                  padding: "8px",
                }}
              >
                1
              </th>
              <th
                key={`sub-2-${index}`}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  border: "1px solid #ccc",
                  padding: "8px",
                }}
              >
                2
              </th>
              <th
                key={`sub-3-${index}`}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  border: "1px solid #ccc",
                  padding: "8px",
                }}
              >
                3
              </th>
            </>
          ))}
        </tr>
      </>
    );
  };

  const handleDetailLaporan = (id_laporan, asset_name) => {
    console.log({ asset_name });

    setSelectedId(id_laporan);
    setModalOpen(true);
    setSelectedAssetName(asset_name);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedId(null);
    setSelectedAssetName(null);
  };

  const renderTableBody = () => {
    return (
      reportExports
        // 1) filter based on your `filter` value
        .filter((item) => {
          const ringCount = parseInt(item.asset.ring, 10);

          // check for each day if laporan length === ringCount
          const isComplete = Array.from({ length: daysInRange }).every(
            (_, dayIndex) => {
              const date = moment(startDate)
                .add(dayIndex, "days")
                .format("YYYY-MM-DD");
              const count = item.laporans?.[date]?.length || 0;
              return count === ringCount;
            }
          );

          if (filter === "Lengkap") return isComplete;
          if (filter === "Belum Lengkap") return !isComplete;
          return true; // 'Semua'
        })
        // 2) then map to rows as before
        .map((item, index) => {
          const { asset, laporans } = item;
          const { kode, name, ring, just_on_holiday } = asset;

          return (
            <tr key={index}>
              <td
                style={{
                  textAlign: "center",
                  border: "1px solid #ccc",
                  padding: "8px",
                }}
              >
                {index + 1}
              </td>
              <td
                style={{
                  textAlign: "left",
                  border: "1px solid #ccc",
                  padding: "8px",
                }}
              >
                {kode}
              </td>
              <td
                style={{
                  textAlign: "left",
                  border: "1px solid #ccc",
                  padding: "8px",
                }}
              >
                {name}
              </td>

              {Array.from({ length: daysInRange }, (_, dayIndex) => {
                const date = moment(startDate)
                  .add(dayIndex, "days")
                  .format("YYYY-MM-DD");
                const dataLaporan = laporans?.[date] || [];

                return Array.from({ length: 3 }, (_, laporanIndex) => {
                  let bg = "#FF0000";
                  if (!laporans?.[date] && just_on_holiday) bg = "#FFFF00";
                  if (laporanIndex >= parseInt(ring, 10)) bg = "#000000";

                  const laporan = dataLaporan[laporanIndex];
                  if (laporan?.is_temuan !== undefined) {
                    bg = laporan.is_temuan ? "#0070C0" : "#92D050";
                  }

                  return (
                    <td
                      key={`${dayIndex}-${laporanIndex}`}
                      style={{
                        backgroundColor: bg,
                        color: bg === "#000000" ? "#fff" : "#000",
                        textAlign: "center",
                        border: "1px solid #ccc",
                        padding: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleDetailLaporan(laporan?.id_laporan, name)
                      }
                    >
                      {laporan?.date_done
                        ? moment.utc(laporan.date_done).format("HH:mm")
                        : ""}
                    </td>
                  );
                });
              })}
            </tr>
          );
        })
    );
  };

  const screens = Grid.useBreakpoint();
  // when viewport is under “lg” (i.e. screens.lg === false), use column,
  // otherwise switch to row
  const direction = screens.lg ? "horizontal" : "vertical";

  // screens.md === true when width ≥ 768px (AntD’s “md” breakpoint)
  const isMdUp = screens.md;
  console.log({ direction });
  const [filter, setFilter] = useState("Semua");
  const [filterDays, setFilterDays] = useState("Hari ini");

  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");

    switch (filterDays) {
      case "Hari ini":
        setStartDate(today);
        break;

      case "Kemarin": {
        const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
        setStartDate(yesterday);
        break;
      }

      case "1 Minggu":
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        break;

      default:
        // if you ever add more presets, handle or ignore
        break;
    }
  }, [filterDays]);

  return (
    <div className="main-content-page">
      <Card
        title={`Laporan Cabang ${query_pel || "Unknown"}`}
        bordered={false}
        styles={{ body: { padding: "16px" } }}
      >
        {isLoading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin size="large" />
          </div>
        ) : id_pelanggan === null ? (
          <Alert
            message="Cabang tidak ditemukan. Silakan hubungi supervisor."
            type="warning"
          />
        ) : (
          <>
            <Space
              size="middle"
              align={direction === "horizontal" ? "center" : "start"}
              style={{ width: "100%" }}
              direction={direction}
            >
              {/* 2) controlled Segmented */}
              <Segmented
                options={["Semua", "Belum Lengkap", "Lengkap"]}
                value={filter}
                onChange={(value) => {
                  setFilter(value);
                  console.log({ value, filter }); // string
                }}
              />
              <Segmented
                options={["Hari ini", "Kemarin", "1 Minggu"]}
                value={filterDays}
                onChange={(value) => {
                  setFilterDays(value);
                  console.log({ value, filter }); // string
                }}
              />

              {/* 3) pass it downstream (or just render it) */}
            </Space>
            <LaporanInformationCard />
            <Divider />
            <table
              style={{
                // under md → block (so it scrolls nicely), md and up → flex
                display: isMdUp ? "masonry" : "block",

                width: "100%",
                // under md → smaller font, md and up → normal
                fontSize: isMdUp ? "0.8rem" : "0.75rem",

                borderCollapse: "collapse",
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <thead>{renderTableHeaders()}</thead>
              <tbody>{renderTableBody()}</tbody>
            </table>
          </>
        )}
      </Card>

      <DetailLaporanModal
        open={isModalOpen}
        id_laporan={selectedId}
        onClose={closeModal}
        asset_name={selectedAssetName}
      />
    </div>
  );
}
